<template lang="pug">
PageArticles(v-if='!isSubPage')
PageArticlesPage(v-else, :alias='alias')
</template>

<script lang="ts" setup>
const { isSubPage, alias } = useMeta();
</script>
